import React from "react";
import { StyledContainer, Wrapper } from "../styled";
import { toast } from "react-toastify";
import { bounce } from "../styledEffects";

const Template = (props) => {
  const customId = "custom-id-yes";
  const notify = (type) => {
    toast(type, {
      toastId: customId,
      transition: bounce,
    });
  };

  return (
    <Wrapper>
      <StyledContainer
        autoClose={900}
        hideProgressBar={true}
        position="top-right"
      >
        {notify(props.children)}
      </StyledContainer>
    </Wrapper>
  );
};

export default Template;
